import requests from "./httpService";

const CommissionPaymentServices = {
  getCommsionpayment: async (body) => {
    return requests.post(
      "/billPayment/franchise-commission-payment-list",
      body,
    );
  },
    UpdateCommsionpayment: async (id,body) => {
    return requests.put(`/billPayment/franchise-commission-payment/${id}`,body);
  },
};

export default CommissionPaymentServices;
